import { render, staticRenderFns } from "./BookingCheckResult.vue?vue&type=template&id=1b142b7b&scoped=true"
import script from "./BookingCheckResult.vue?vue&type=script&lang=js"
export * from "./BookingCheckResult.vue?vue&type=script&lang=js"
import style0 from "./BookingCheckResult.vue?vue&type=style&index=0&id=1b142b7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b142b7b",
  null
  
)

export default component.exports